import aboutLogo from '../assets/aboutLogo.png';
const AboutSection = () => {
  return (
       <section className="about-section" id="about">
        <div className="about-container">
            <div className="about-content">
                <h2>About <span className="highlight">Socialuk</span></h2>
                <p>At Socialuk, we're passionate about crafting joyful gaming experiences. Our creative team brings
                    futuristic and exciting worlds to life, where every spin sparks a new adventure. Our Jackpot Slots
                    is just one of our exciting projects, and we're thrilled to share this digital ride with players
                    everywhere.</p>

                <h3>Our Mission</h3>
                <p>Socialuk is a dedicated team of dreamers and creators, united by a love for games that inspire
                    smiles and fun. Our platform showcases our innovative spirit, blending cutting-edge design with pure
                    entertainment.</p>

                <h3>Usage & License</h3>
                <p>Socialuk Slots is a free-to-play social casino game designed exclusively for entertainment. No
                    real money or prizes are involved. This game is intended for players seeking lighthearted fun
                    without any risks.</p>

                <h3>Contact Us</h3>
                <p>Have feedback, questions, or just want to say hello? We'd love to hear from you! Reach out and let's
                    keep the conversation going.</p>
            </div>
            <div className="about-image">
                <div className="crypto-graphic">
                    <img src={aboutLogo} alt="Socialuk Logo" />
                </div>
            </div>
        </div>
    </section>
  )
}

export default AboutSection